import * as React from "react";
import { useState, useEffect } from "react";
import { Paper, TableRow, TableHead, TableCell, TableBody, Table } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { parseNewDateToDDMMYYYnoTime } from "../../../../Utils/dateHelper";
import { Plus, Minus } from "lucide-react";
import { controlTypes, externalApiTypes } from "../../../../Config/constants";

export default function FinancialSummaryTable(props) {
  const classes = useStyles();
  const [currency, setCurrency] = useState({ symbol: "€", name: "Euro" });

  useEffect(() => {
    if (props.currency) {
      setCurrency(props.currency);
    }
  }, [props.currency]);

  const isStopwatch = (measurement) => {
    let measurementControlTypeId = measurement.type;
    let measurementExternalApiTypeId = measurement.externalApiTypeId;

    if (measurementControlTypeId === controlTypes.STOPWATCH || (measurementControlTypeId === controlTypes.EXTERNALAPI && measurementExternalApiTypeId === externalApiTypes.STOPWATCH)) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className={classes.summaryContainer} component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Event</TableCell>
            <TableCell align="left">Registration point</TableCell>
            <TableCell align="right">First occurence</TableCell>
            <TableCell align="right">Last occurence</TableCell>
            <TableCell align="right">Amount</TableCell>
            <TableCell align="right">Price per hour/event</TableCell>
            <TableCell align="right">Total price</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.priceData.length === 0 ? (
            <tr>
              <td colSpan="9" style={{ paddingTop: "24px", paddingBottom: "24px" }}>
                <div className={classes.emptyStateCard}>
                  <p className={classes.emptyStateCard__title}>No data</p>
                  <p className={classes.emptyStateCard__subtitle}>There is no data to display.</p>
                </div>
              </td>
            </tr>
          ) : (
            <React.Fragment></React.Fragment>
          )}
          {props.priceData
            .sort((a, b) => a.detailDescription.localeCompare(b.detailDescription))
            .map((measurement, index) => (
              <TableRow key={`measurmentRow_${index}_${measurement.id}`} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                <TableCell component="th" scope="row">
                  {measurement.detailDescription}
                </TableCell>
                <TableCell align="left">{measurement.resourceName}</TableCell>
                <TableCell align="right">{measurement.first !== null ? parseNewDateToDDMMYYYnoTime(new Date(measurement.first)) : "-"}</TableCell>
                <TableCell align="right">{measurement.last !== null ? parseNewDateToDDMMYYYnoTime(new Date(measurement.last)) : "-"}</TableCell>
                <TableCell align="right">{!isStopwatch(measurement) ? measurement.amount : measurement.minuteamount}</TableCell>
                <TableCell align="right">{currency.symbol + measurement.price.toLocaleString("nl-BE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                <TableCell style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }} align="right">
                  {currency.symbol + measurement.totalPrice.toLocaleString("nl-BE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  {measurement.isProfit ? <Plus style={{ color: "rgb(40, 167, 69)" }} /> : <Minus style={{ color: "rgb(220, 53, 69)" }} />}
                </TableCell>
              </TableRow>
            ))}

          <TableRow>
            <TableCell colSpan={6} style={{ fontWeight: "bold" }}>
              <span style={{ float: "right" }}>Total</span>
            </TableCell>
            <TableCell style={{ fontWeight: "bold" }} align="right">
              {currency.symbol + props.totalPrice.toLocaleString("nl-BE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  );
}
const useStyles = makeStyles((theme) => ({
  summaryContainer: {
    overflowX: "scroll",

    // remove scrollbar
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
  },

  emptyStateCard: {
    maxWidth: "320px",
    boxSizing: "border-box",

    padding: "16px",
    margin: "auto",

    display: "flex",
    flexDirection: "column",

    alignItems: "center",

    backgroundColor: "transparent",
  },

  emptyStateCard__title: {
    fontFamily: "Lato, sans-serif",
    fontSize: "16px",
    color: "rgba(12, 14, 41, 1)",

    margin: "0px",
    marginBottom: "8px",
  },

  emptyStateCard__subtitle: {
    fontFamily: "Lato, sans-serif",
    fontSize: "14px",
    color: "rgba(12, 14, 41, 0.8)",

    textAlign: "center",

    margin: "0px",
  },
}));
